export const getFullName = (firstName, lastName) => {
  const firstNameUpper = firstName?.slice(0, 1).toUpperCase() + firstName?.slice(1)
  const lastNameUpper = lastName?.slice(0, 1).toUpperCase() + lastName?.slice(1)

  return `${firstNameUpper} ${lastNameUpper}`
}

export const getProfileImageAvailability = profileImage => (profileImage ? profileImage : "")
